import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'app-date-picker',
  imports: [
    CommonModule, FormsModule,
    MatDatepickerModule, MatNativeDateModule,
    MatFormFieldModule, MatInputModule, MatIconModule
  ],
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DatePickerComponent),
    multi: true
  }]
})
export class DatePickerComponent implements ControlValueAccessor {
  @Input() label = 'Date';
  @Input() placeholder = 'Select date';
  @Input() required = false;
  @Input() maxDate: Date | null = null;
  @Input() minDate: Date | null = null;

  value: Date | null = null;
  disabled = false;

  private onChange: (v: any) => void = () => {};
  private onTouched: () => void = () => {};

  onDateChange(date: Date | null): void {
    this.value = date;
    const str = date ? this.toDateString(date) : '';
    this.onChange(str);
    this.onTouched();
  }

  writeValue(val: string | Date | null): void {
    if (!val) { this.value = null; return; }
    if (typeof val === 'string') {
      this.value = val ? new Date(val + 'T00:00:00') : null;
    } else {
      this.value = val;
    }
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(d: boolean): void { this.disabled = d; }

  private toDateString(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
}
